interface Props {
	src?: string;
}

export const PdfView_SAL2030_R01 = (props: Props) => {
	const { src } = props;

	return (
		<div className="w-full h-full min-h-0 border border-gray-300 rounded bg-white overflow-hidden">
			{src ? (
				<iframe
					src={src}
					title="일일 매출일보"
					className="w-full h-full border-0"
				/>
			) : null}
		</div>
	);
};
